const envBase = process.env.REACT_APP_INTERIOR_AI_BACKEND_URL?.trim();

export const API_BASE =
  envBase && envBase.length > 0
    ? envBase.replace(/\/$/, "")
    : `${window.location.protocol}//${window.location.hostname}:8001`;

const NGROK_HEADERS = {
  "ngrok-skip-browser-warning": "true",
};

async function parseJsonSafely(res) {
  const text = await res.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    throw new Error(`Invalid JSON response from ${res.url}`);
  }
}

export async function postForm(path, form) {
  const token = localStorage.getItem("token");
  if (token && !form.has("token")) form.append("token", token);

  const res = await fetch(`${API_BASE}${path}`, {
    method: "POST",
    body: form,
    cache: "no-store",
    headers: { ...NGROK_HEADERS },
  });

  const data = await parseJsonSafely(res);
  if (!res.ok) throw new Error(data?.detail ?? data?.error ?? "Request failed");
  return data;
}

export async function getJobStatus(jobId) {
  if (!jobId || String(jobId).trim() === "") {
    throw new Error("Missing job_id for status polling");
  }

  const url = new URL(`${API_BASE}/jobs/${encodeURIComponent(jobId)}`);
  url.searchParams.set("_ts", Date.now().toString());

  const res = await fetch(url.toString(), {
    method: "GET",
    cache: "no-store",
    headers: {
      ...NGROK_HEADERS,
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
    },
  });

  const data = await parseJsonSafely(res);
  if (!res.ok) {
    throw new Error(data?.detail ?? data?.error ?? "Failed to fetch job status");
  }
  return data;
}
